export { default as withPaginator } from './withPaginator';
export { default as Pagination } from './Pagination';


// WEBPACK FOOTER //
// ./resources/assets/js/components/Pagination/index.js